import styled from 'styled-components';

const AppCardLogo = styled.div`
  box-sizing: border-box;
  width: ${(props) => (props.small ? '50px' : '100px')};
  height: ${(props) => (props.small ? '50px' : '100px')};
  margin: 0;
  padding: ${(props) => (props.small ? '5px' : '10px')};
  background-color: #fff;
  border-radius: 4px;

  & > img {
    max-width: ${(props) => (props.small ? '40px' : '80px')};
    max-height: ${(props) => (props.small ? '40px' : '80px')};
  }
`;

AppCardLogo.displayName = 'AppCardLogo';

export { AppCardLogo };
